import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

// Define all services with their paths and titles
const allServices = [
  { path: '/research-paper-writing-service', title: 'Research Paper Writing' },
  { path: '/programming-assignment-help-service', title: 'Programming Assignment Help' },
  { path: '/database-management-service', title: 'Database Management' },
  { path: '/affordable-accounting-class-help', title: 'Accounting Class Help' },
  { path: '/affordable-accounting-assignment-help', title: 'Accounting Assignment Help' },
  { path: '/take-my-online-chemistry-class-for-me', title: 'Chemistry Class Help' },
  { path: '/blog', title: 'Blog' },
  { path: '/coding-assignment-help-services', title: 'Coding Assignment Help' },
  { path: '/urgent-essay-writing-help', title: 'Urgent Essay Writing Help' },
  { path: '/terms-conditions', title: 'Terms & Conditions' },
  { path: '/hire-someone-to-take-my-exam', title: 'Exam Taking Service' },
  { path: '/physics-homework-help-service', title: 'Physics Homework Help' },
  { path: '/best-python-assignment-help', title: 'Python Assignment Help' },
  { path: '/how-it-works', title: 'How It Works' },
  { path: '/physics-class-help-service', title: 'Physics Class Help' },
  { path: '/dissertation-writing-service', title: 'Dissertation Writing' },
  { path: '/homework-help-service', title: 'Homework Help Service' },
  { path: '/testimonials', title: 'Testimonials' },
  { path: '/powerpoint-presentation-service', title: 'PowerPoint Presentations' },
  { path: '/last-minute-essay-help', title: 'Last Minute Essay Help' },
  { path: '/database-assignment-help-service', title: 'Database Assignment Help' },
  { path: '/statistics-assignment-help-service', title: 'Statistics Assignment Help' },
  { path: '/spss-assignment-help', title: 'SPSS Assignment Help' },
  { path: '/urgent-essay-writing-help', title: 'Urgent Essay Writing' },
  { path: '/math-assignment-help-service', title: 'Math Assignment Help' },
  { path: '/order', title: 'Order Now' },
  { path: '/someone-to-take-my-online-class', title: 'Take My Online Class' },
  { path: '/statistics-class-helper', title: 'Statistics Homework Helper' },
  { path: '/refund-guarantee', title: 'Refund Guarantee' },
  { path: '/contact', title: 'Contact Us' },
  { path: '/online-class-help-services', title: 'Class Help Directory' },
  { path: '/services', title: 'All Services' },
  { path: '/affordable-dissertation-writers', title: 'Affordable Dissertation Writing' },
  { path: '/privacy-policy', title: 'Privacy Policy' },
  { path: '/faq', title: 'FAQ' }
];

interface RelatedServicesProps {
  currentPath: string;
  count?: number;
  title?: string;
}

/**
 * RelatedServices component to display links to other service pages
 * Helps ensure every page has incoming internal links
 */
const RelatedServices: React.FC<RelatedServicesProps> = ({ 
  currentPath, 
  count = 3,
  title = "Related Services"
}) => {
  // Filter out the current page and select random related services
  const otherServices = allServices
    .filter(service => service.path !== currentPath)
    .sort(() => 0.5 - Math.random())
    .slice(0, count);

  return (
    <div className="related-services my-5">
      <h3 className="text-center mb-4">{title}</h3>
      <Row className="justify-content-center">
        {otherServices.map((service, index) => (
          <Col md={4} sm={6} className="mb-3" key={index}>
            <Card className="h-100 related-service-card">
              <Card.Body>
                <Card.Title>{service.title}</Card.Title>
                <Link to={service.path} className="stretched-link mt-2 d-block">
                  Learn More <FontAwesomeIcon icon={faArrowRight} />
                </Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default RelatedServices; 